exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/About.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-contact-js": () => import("./../../../src/pages/Contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-jewellery-js": () => import("./../../../src/pages/Jewellery.js" /* webpackChunkName: "component---src-pages-jewellery-js" */),
  "component---src-pages-text-js": () => import("./../../../src/pages/Text.js" /* webpackChunkName: "component---src-pages-text-js" */)
}

